import React, { useState } from "react";
// import Blog from '../component/Blog'
import { Helmet } from "react-helmet";
import SecondaryBtn from '../component/btn/SecondaryBtn'
import Counter from '../component/Counter'
import Cta from '../component/Cta'
import Faq from '../component/Faq'
import HorizontalSlider from '../component/slider/HorizontalSlider'
import ImageTextSlider from '../component/slider/ImageTextSlider'
import about01 from '../images/about-img01.png'
import videsh05 from '../images/videsh05.png'
import { Icon } from "@iconify/react";
import EnquiryForm from "../component/forms/EnquireForm";

export default function ParcelVidesh() {
    const faqData = [
    {
        question: "What is ParcelX Videsh?",
        answer: "ParcelX Videsh is an international shipping service that enables you to send parcels from India to 220+ countries with ease. It simplifies global logistics by providing access to multiple courier partners, competitive rates, and a seamless shipping experience from pickup to delivery.",
    },
    {
        question: "Who can use ParcelX Videsh?",
        answer: "ParcelX Videsh is designed for everyone—D2C brands, e-commerce sellers, exporters, small businesses, and even individuals who want to send personal parcels internationally. Whether you're shipping occasionally or in bulk, it fits all needs.",
    },
    {
        question: "How long does delivery take?",
        answer: "Delivery timelines typically range from 2–7 business days, depending on the destination, courier partner, and customs clearance. Express options are also available for faster delivery.",
    },
    {
        question: "What documents are required?",
        answer: "Basic documents such as an invoice, KYC details, and shipment information are required. Depending on the shipment type and destination, additional documents may be needed, and ParcelX assists you throughout the process.",
    },
    ];
    const [country, setCountry] = useState("All Country");
    const countries = [
        "Select Country",
        "Afghanistan",
        "Albania",
        "Algeria",
        "Andorra",
        "Angola",
        "Argentina",
        "Armenia",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Chad",
        "Chile",
        "China",
        "Colombia",
        "Comoros",
        "Congo",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Fiji",
        "Finland",
        "France",
        "Gabon",
        "Gambia",
        "Georgia",
        "Germany",
        "Ghana",
        "Greece",
        "Guatemala",
        "Guinea",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Lithuania",
        "Luxembourg",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Mauritania",
        "Mauritius",
        "Mexico",
        "Moldova",
        "Mongolia",
        "Montenegro",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nepal",
        "Netherlands",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "North Korea",
        "Norway",
        "Oman",
        "Pakistan",
        "Panama",
        "Paraguay",
        "Peru",
        "Philippines",
        "Poland",
        "Portugal",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Somalia",
        "South Africa",
        "South Korea",
        "Spain",
        "Sri Lanka",
        "Sudan",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tunisia",
        "Turkey",
        "Uganda",
        "Ukraine",
        "United Arab Emirates",
        "United Kingdom",
        "United States",
        "Uruguay",
        "Uzbekistan",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
        ];
  return (
    <div>
        <Helmet>
            <title>Parcelx - Videsh</title>
        </Helmet>
        <section className="section01">
            <div className="container-fluid">
                <div className='col-md-11 mx-auto'>
                    <div className='row'>
                        <div className='col-md-4 order-md-2 position-relative text-md-right'>
                            <img className='img-fluid right-image top-40' src={about01} />
                        </div>
                        <div className='col-md-8'>
                            <h3 className='pt-5'>Videsh: Affordable International Shipping</h3>
                            <p>Ship globally without complexity—ParcelX Videsh connects you and your business to 220+ countries with ease. From documentation and customs support to reliable courier partners and real-time tracking, everything is handled seamlessly in one platform. </p>
                            <SecondaryBtn text={'Get Started'} href="https://seller.parcelx.in/register" />
                            <div className='counter-main-box'>
                                <Counter target={50} suffix="K" label="Happy Customers" />
                                <Counter value="1Mn+" label="Shipments Delivered" />
                                <Counter target={220} suffix="+" label="Countries" />
                            </div>
                        </div>
                    </div>
                </div>     
            </div>
        </section>
        <section className="slice" id="contact">
            <div className="container-fluid">
                <div className="col-md-11 mx-auto">
                    <div className="text-center mb-5">
                        <div className="subheading">Unlock Global Shipping for Your Business</div>
                        <p>Drop your details & our executive will connect with you</p>
                    </div>
                    <div className='fulfill-box'>
                        <div className='fulfill-img-box'>
                            <img src={videsh05} alt='get in touch' className='img-fluid' />
                        </div> 
                        <div className='fulfill-content'>
                            <EnquiryForm countries={countries} />
                        </div>   
                    </div>
                </div>
            </div>
        </section>
        <ImageTextSlider />
        <section className='section02 pt-0'>
            <div className='container-fluid'>
                <div className='col-md-11 mx-auto'>
                    <HorizontalSlider />
                </div>
            </div>
        </section>
        <Faq
        title={{
            highlight: "Frequently Asked Question:",
            text: "Find answers to our most asked questions",
        }}
        faqs={faqData}
        />
        {/* <Blog /> */}
        <Cta />
    </div>
  )
}
